enum BrokerCommissionFormatEnum {
    Dollars = 'DOLLARS',
    Percentage = 'PERCENTAGE',
}

export default BrokerCommissionFormatEnum;
